import { render, staticRenderFns } from "./interestTransfer.vue?vue&type=template&id=8711c7ea&scoped=true&"
import script from "./interestTransfer.vue?vue&type=script&lang=js&"
export * from "./interestTransfer.vue?vue&type=script&lang=js&"
import style0 from "./interestTransfer.vue?vue&type=style&index=0&id=8711c7ea&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8711c7ea",
  null
  
)

export default component.exports